import { toast } from "react-toastify";
import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer"

//Include Both Helper File with needed methods
import { putForgetPassword } from "helpers/backend_helper";
import { Environment } from "environment";



export const userForgetPassword = (user : any, navigate : any , ) => async (dispatch : any) => {
  try {
      let response;
      if (Environment.apiUrl) {

          response = await putForgetPassword(
              {
                username : user.username ,
              }
          )
      }
      const data : any = await response;

      if (data.success ) {
          dispatch(userForgetPasswordSuccess(
              "Reset link are sended to your mailbox, check there first"
          ))
          toast.success("link sent to your email to update passwword");
          navigate("/login"); 
      }
      else {
        toast.error("user not found", {
          autoClose: 1000,
        });
        navigate("/login");
     
      }
  } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError))
  }
}



export const userForgetPasswordUpdate = (user: any) => async (dispatch: any) => {
  try {
    let response;

    if (Environment.apiUrl) {
      response = await putForgetPassword({
        username: user.username,
      });
    }

    const data: any = await response;

    if (data.success) {
      dispatch(userForgetPasswordSuccess("Reset link sent"));
      return { success: true, message: "Link sent to your email to update password" };
    } else {
      return { success: false, message: data.message || "Failed to send reset link" };
    }
  } catch (forgetError) {
    dispatch(userForgetPasswordError(forgetError));
    return { success: false, message: "Something went wrong" };
  }
};